import React from 'react';
import PropTypes from 'prop-types';
import { IndexLink } from 'react-router';
import _ from 'lodash';
import classNames from 'classnames';
import { canDisplayUpsell } from 'helpers/ContentHelper';
import { helperGetHomeUrl, helperGetNetworkUpsellUrl } from 'helpers/RouteHelper';
import NetworkImage from 'components/NetworkImage';
import Style from './NetworkLink.module.scss';

const NetworkLink = props => {
  const { alt, clickEvent, disableLink, isFreemium, isHeader, preauthorizedResources } = props;
  const displayUpsell = canDisplayUpsell(preauthorizedResources);
  let to = helperGetHomeUrl();
  let onClick = clickEvent;
  if (displayUpsell) {
    const upsellUrl = helperGetNetworkUpsellUrl();
    to = upsellUrl;
    if (isFreemium) {
      to = helperGetHomeUrl();
    } else {
      to = null;
      onClick = e => {
        e.preventDefault();
        clickEvent(e);
        // force reload on nation to allow akami redirect for users not logged in
        // so that they return back to the auth/sub page
        window.location.href = upsellUrl;
      };
    }
  }
  const classes = [];
  const indexIsSlash = to === '/';

  classes.push(Style.logo);
  const className = classNames(classes);
  const linkProps = {
    className,
    onClick,
  };
  const network = _.get(window.ExternalConfig, 'brand.headerLogo', null);
  const networkImageProps = {};
  if (network) networkImageProps.network = network;
  if (alt) networkImageProps.alt = alt;
  if (!disableLink) {
    linkProps.href = to;
    linkProps.to = to;
  }
  const networkImage = <NetworkImage {...networkImageProps} />;

  if (!indexIsSlash && !isHeader) return <a {...linkProps}>{networkImage}</a>;

  return <IndexLink {...linkProps}>{networkImage}</IndexLink>;
};

NetworkLink.defaultProps = {
  clickEvent: () => {},
  disableLink: false,
  hideNetworkLogo: false,
  isFreemium: false,
  isHeader: null,
  preauthorizedResources: null,
};

NetworkLink.propTypes = {
  alt: PropTypes.string,
  clickEvent: PropTypes.func,
  disableLink: PropTypes.bool,
  hideNetworkLogo: PropTypes.bool,
  isFreemium: PropTypes.bool,
  isHeader: PropTypes.bool,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
};

export default NetworkLink;
